import { Badge } from '@/components/ui/badge';
import type { DemoDeLaEmpresa } from '../types/admin.types';
import { pastillasDeLaDemo } from '../lib/demo-textos';

/**
 * Las pastillas de una empresa en prueba en la lista y en la ficha: «Lista para la venta»,
 * «Misiones k/6», «Sin ingresos hace N días» y «Rubro sin tiendas». Sólo cuentan lo que el servidor
 * dijo (`demo`); sin `demo` (una empresa con plan completo) no dibuja nada.
 */
export function PastillasDeLaDemo({
  demo,
  misiones,
}: {
  demo?: DemoDeLaEmpresa | null;
  misiones?: { hechas: number; total: number } | null;
}) {
  const pastillas = pastillasDeLaDemo(demo, misiones);
  if (pastillas.length === 0) return null;
  return (
    <ul className="mt-1 flex flex-wrap gap-1" aria-label="Estado de la prueba">
      {pastillas.map((p) => (
        <li key={p.clave}>
          <Badge variant={p.variante} title={p.ayuda} className="px-2 py-0 text-[11px]">
            {p.texto}
          </Badge>
        </li>
      ))}
    </ul>
  );
}
